import { types } from "mobx-state-tree";

export const Mk8sDraftProviderGCPAMIReadOnlyModel = types.model({
  type: types.optional(types.enumeration(["recommended", "family", "exact"]), "recommended"),
  recommended: types.optional(types.string, ""),
  familyProject: types.optional(types.string, ""),
  familyFamily: types.optional(types.string, ""),
  exact: types.optional(types.string, ""),
});

export const Mk8sDraftProviderGCPAMIModel = types
  .model({
    type: types.optional(types.enumeration(["recommended", "family", "exact"]), "recommended"),
    recommended: types.optional(types.string, ""),
    familyProject: types.optional(types.string, ""),
    familyFamily: types.optional(types.string, ""),
    exact: types.optional(types.string, ""),
  })
  .actions((self) => ({
    setType(value: "recommended" | "family" | "exact") {
      self.type = value;
    },
    setRecommended(value: string) {
      self.recommended = value;
    },
    setFamilyProject(value: string) {
      self.familyProject = value;
    },
    setFamilyFamily(value: string) {
      self.familyFamily = value;
    },
    setExact(value: string) {
      self.exact = value;
    },
  }))
  .views((self) => ({
    get isValid() {
      if (self.type === "recommended") {
        return !!self.recommended;
      }
      if (self.type === "exact") {
        return !!self.exact;
      }
      if (self.type === "family") {
        return !!self.familyProject && !!self.familyFamily;
      }
      return false;
    },
    get isValidForNodePool() {
      if (self.type === "family") {
        return !!self.familyProject && !!self.familyFamily;
      }
      return true;
    },
  }));
